import { render, staticRenderFns } from "./CustomerCardTypeForm.vue?vue&type=template&id=af8eda1e&"
import script from "./CustomerCardTypeForm.vue?vue&type=script&lang=js&"
export * from "./CustomerCardTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports